import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  BillApprovalChainOption,
  type BillApprovalChainOptionConstructor,
} from './BillApprovalChainOption'

export const BillApprovalChainOptionConstructorFactory =
  Factory.Sync.makeFactory<BillApprovalChainOptionConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.commerce.department()),
  })

export const BillApprovalChainOptionFactory = EntityFactory(
  BillApprovalChainOption,
  BillApprovalChainOptionConstructorFactory
)
